import { makeStyles } from "@mui/styles";
export var useGalleryStyles = makeStyles(function (theme) { return ({
    root: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    item: {
        flexShrink: 0,
        width: "30%",
        height: "322px",
        position: "relative",
        cursor: "pointer",
        border: "4px solid transparent",
        boxSizing: "border-box",
    },
    itemImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    itemHover: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: -9999,
        opacity: 0,
        background: "linear-gradient(180deg, rgba(0, 0, 0, 0) -9.73%, rgba(0, 0, 0, 0.8) 100%)",
        transition: "opacity 0.5s ease-in",
    },
    itemHoverText: {
        marginTop: "75%",
        color: theme.design.colors.waz_white,
        textAlign: "center",
        fontSize: "24px",
        fontWeight: "bold",
        cursor: "pointer",
        zIndex: 10,
    },
    itemHoverActive: {
        zIndex: 5,
        opacity: 1,
    },
    itemChecked: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: -9999,
        opacity: 0,
        background: "rgba(255, 255, 255, 0.3)",
        transition: "opacity 0.5s ease-in",
        "& .checkbox": {
            position: "absolute",
            right: "1%",
        },
    },
    itemCheckedActive: {
        zIndex: 10,
        opacity: 1,
        border: "4px solid ".concat(theme.design.colors.waz_dangerColor),
    },
}); });
